<template>
  <div id="printable" class="register-container">
    <!-- Header -->
    <div class="header">
      <div class="facility-name">
        TUURU COTTOLENGO HEALTH CENTRE - AR2026259
      </div>
      <div class="facility-details">
        <div>Igembe Central</div>
        <div>P.O BOX 77 - Meru | Tel: 254254746758069</div>
        <div>Email: suore.tuuru@cottolengo.org</div>
      </div>
      <div class="register-title">MOH 516 - REFERRAL REGISTER</div>
    </div>

    <!-- Date Range and Generated By Bar -->
    <div class="info-bar">
      <div class="info-left">
        <div class="date-range">
          <div class="info-item">
            <span class="info-label">From:</span>
            <input
              type="date"
              v-model="dateFrom"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <div class="info-item">
            <span class="info-label">To:</span>
            <input
              type="date"
              v-model="dateTo"
              class="date-input"
              @change="filterRecords"
            />
          </div>
          <button @click="clearDates" class="btn-clear">Clear</button>
        </div>
        <div class="info-item">
          <span class="info-label">Generated By:</span>
          <span class="info-value">{{ generatedBy }}</span>
        </div>
      </div>
      <button @click="printPage" class="btn-print">Print Register</button>
    </div>

    <!-- Date Range Display for Print -->
    <div class="print-date-range">
      <strong>Report Period:</strong> {{ formattedDateFrom }} to
      {{ formattedDateTo }}
    </div>

    <!-- Summary Statistics -->
    <div class="summary-stats">
      <div class="stat-box">
        <span class="stat-label">Total Referrals</span>
        <span class="stat-number">{{ totalReferrals }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Referrals Out</span>
        <span class="stat-number">{{ referralsOut }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Referrals In</span>
        <span class="stat-number">{{ referralsIn }}</span>
      </div>
      <div class="stat-box">
        <span class="stat-label">Feedback Received</span>
        <span class="stat-number">{{ feedbackReceived }}</span>
      </div>
    </div>

    <!-- Table -->
    <div class="table-wrapper">
      <table class="referral-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Referral Date</th>
            <th>Referral No</th>
            <th>Patient Names</th>
            <th>Age</th>
            <th>Sex</th>
            <th>Contact</th>
            <th>SubLocation</th>
            <th>Diagnosis</th>
            <th>Reason for Referral</th>
            <th>Referral Type</th>
            <th>Referred From</th>
            <th>Referred To</th>
            <th>Referral Status</th>
            <th>Referral Outcome</th>
            <th>Feedback Date</th>
            <th>Feedback</th>
            <th>Referred By</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(record, index) in filteredRecords" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ record.referralDate }}</td>
            <td>{{ record.referralNo }}</td>
            <td>{{ record.patientNames }}</td>
            <td>{{ record.age }}</td>
            <td class="text-center">{{ record.sex }}</td>
            <td>{{ record.contact }}</td>
            <td>{{ record.subLocation }}</td>
            <td>{{ record.diagnosis }}</td>
            <td>{{ record.reason }}</td>
            <td class="text-center">
              <span
                :class="
                  record.referralType === 'Out' ? 'out-badge' : 'in-badge'
                "
              >
                {{ record.referralType }}
              </span>
            </td>
            <td>{{ record.referredFrom }}</td>
            <td>{{ record.referredTo }}</td>
            <td class="text-center">
              <span :class="getStatusClass(record.referralStatus)">
                {{ record.referralStatus }}
              </span>
            </td>
            <td>{{ record.referralOutcome }}</td>
            <td>{{ record.feedbackDate }}</td>
            <td>{{ record.feedback }}</td>
            <td>{{ record.referredBy }}</td>
            <td>{{ record.remarks }}</td>
          </tr>
          <tr v-if="filteredRecords.length === 0">
            <td colspan="19" class="empty-row">
              No referral records found for the selected date range
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: "MOH516Referral",
  data() {
    return {
      dateFrom: "2026-04-01",
      dateTo: "2026-04-30",
      generatedBy: "SR. JANE KAREGI MUNYUGI",
      referralRecords: [
        {
          referralDate: "2026-04-22",
          referralNo: "REF001",
          patientNames: "John Mwenda",
          age: 45,
          sex: "M",
          contact: "0712345678",
          subLocation: "Kianjai",
          diagnosis: "Severe Malaria with complications",
          reason: "Required blood transfusion and advanced care",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Patient admitted, treated and discharged",
          feedbackDate: "2026-04-25",
          feedback:
            "Patient responded well to treatment. Discharged on 24/04/2026.",
          referredBy: "Dr. S. Mwangi",
          remarks: "Emergency referral",
        },
        {
          referralDate: "2026-04-22",
          referralNo: "REF002",
          patientNames: "Mary Wanjiku",
          age: 32,
          sex: "F",
          contact: "0723456789",
          subLocation: "Mutuati",
          diagnosis: "Obstructed Labour",
          reason: "C-section required",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Emergency C-section done, mother and baby well",
          feedbackDate: "2026-04-23",
          feedback: "Uncomplicated C-section. Discharged after 3 days.",
          referredBy: "Dr. A. Muchene",
          remarks: "Urgent referral",
        },
        {
          referralDate: "2026-04-21",
          referralNo: "REF003",
          patientNames: "Peter Kimathi",
          age: 8,
          sex: "M",
          contact: "0734567890",
          subLocation: "Kangeta",
          diagnosis: "Severe Pneumonia with hypoxia",
          reason: "Required oxygen and pediatric ICU",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Admitted in pediatric ward, improved",
          feedbackDate: "2026-04-24",
          feedback: "Patient on oxygen for 2 days, now stable.",
          referredBy: "Dr. S. Mwangi",
          remarks: "Pediatric emergency",
        },
        {
          referralDate: "2026-04-20",
          referralNo: "REF004",
          patientNames: "Grace Muthoni",
          age: 35,
          sex: "F",
          contact: "0745678901",
          subLocation: "Laare",
          diagnosis: "Hypertensive Emergency",
          reason: "BP 200/120, required specialist care",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Admitted in medical ward, BP controlled",
          feedbackDate: "2026-04-22",
          feedback: "Patient stabilized, discharged on antihypertensives.",
          referredBy: "Dr. A. Muchene",
          remarks: "Medical emergency",
        },
        {
          referralDate: "2026-04-19",
          referralNo: "REF005",
          patientNames: "James Mwirigi",
          age: 52,
          sex: "M",
          contact: "0756789012",
          subLocation: "Kianjai",
          diagnosis: "Diabetic Ketoacidosis",
          reason: "Required intensive care",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Admitted in ICU, recovered",
          feedbackDate: "2026-04-24",
          feedback: "Patient discharged after 5 days on insulin therapy.",
          referredBy: "Dr. S. Mwangi",
          remarks: "Critical referral",
        },
        {
          referralDate: "2026-04-18",
          referralNo: "REF006",
          patientNames: "Esther Kendi",
          age: 28,
          sex: "F",
          contact: "0767890123",
          subLocation: "Mutuati",
          diagnosis: "Severe Preeclampsia",
          reason: "Required specialist obstetric care",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Admitted, delivered safely by C-section",
          feedbackDate: "2026-04-21",
          feedback: "Mother and baby well. Discharged on day 4.",
          referredBy: "Dr. A. Muchene",
          remarks: "Obstetric referral",
        },
        {
          referralDate: "2026-04-17",
          referralNo: "REF007",
          patientNames: "Naomi Gacheri",
          age: 6,
          sex: "F",
          contact: "0778901234",
          subLocation: "Kangeta",
          diagnosis: "Severe Burn Wounds",
          reason: "Required specialized burn care",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Admitted in surgical ward, wound care",
          feedbackDate: "2026-04-20",
          feedback: "Wound debridement done. Improving.",
          referredBy: "Dr. S. Mwangi",
          remarks: "Paediatric burn case",
        },
        {
          referralDate: "2026-04-16",
          referralNo: "REF008",
          patientNames: "Samuel Mutuma",
          age: 45,
          sex: "M",
          contact: "0789012345",
          subLocation: "Laare",
          diagnosis: "Suspected Appendicitis",
          reason: "Required surgical consultation",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Emergency appendectomy performed",
          feedbackDate: "2026-04-18",
          feedback: "Surgery successful. Discharged on day 4.",
          referredBy: "Dr. A. Muchene",
          remarks: "Surgical emergency",
        },
        {
          referralDate: "2026-04-15",
          referralNo: "REF009",
          patientNames: "Mercy Kajuju",
          age: 3,
          sex: "F",
          contact: "0790123456",
          subLocation: "Kianjai",
          diagnosis: "Severe Malnutrition with complications",
          reason: "Required nutrition rehabilitation",
          referralType: "Out",
          referredFrom: "Tuuru Cottolengo HC",
          referredTo: "Meru Level 5 Hospital",
          referralStatus: "Accepted",
          referralOutcome: "Admitted in nutrition unit",
          feedbackDate: "2026-04-19",
          feedback: "On therapeutic feeding program. Gaining weight.",
          referredBy: "Dr. S. Mwangi",
          remarks: "Nutritional referral",
        },
      ],
    };
  },
  computed: {
    formattedDateFrom() {
      return this.dateFrom
        ? new Date(this.dateFrom).toLocaleDateString("en-GB")
        : "Start";
    },
    formattedDateTo() {
      return this.dateTo
        ? new Date(this.dateTo).toLocaleDateString("en-GB")
        : "End";
    },
    filteredRecords() {
      let filtered = this.referralRecords;
      if (this.dateFrom) {
        filtered = filtered.filter((r) => r.referralDate >= this.dateFrom);
      }
      if (this.dateTo) {
        filtered = filtered.filter((r) => r.referralDate <= this.dateTo);
      }
      return filtered;
    },
    totalReferrals() {
      return this.filteredRecords.length;
    },
    referralsOut() {
      return this.filteredRecords.filter((r) => r.referralType === "Out")
        .length;
    },
    referralsIn() {
      return this.filteredRecords.filter((r) => r.referralType === "In").length;
    },
    feedbackReceived() {
      return this.filteredRecords.filter(
        (r) => r.feedback && r.feedback !== "" && r.feedbackDate,
      ).length;
    },
  },
  methods: {
    getStatusClass(status) {
      switch (status) {
        case "Accepted":
          return "status-accepted";
        case "Pending":
          return "status-pending";
        case "Rejected":
          return "status-rejected";
        case "Completed":
          return "status-completed";
        default:
          return "status-pending";
      }
    },
    clearDates() {
      this.dateFrom = "";
      this.dateTo = "";
    },
    filterRecords() {
      // Computed property handles filtering
    },
    printPage() {
      window.print();
    },
  },
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.register-container {
  background: white;
  min-height: 100vh;
  padding: 20px;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
}

.header {
  text-align: center;
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 2px solid #1a56db;
}

.facility-name {
  font-size: 20px;
  font-weight: bold;
  color: #1a56db;
  margin-bottom: 6px;
}

.facility-details {
  font-size: 11px;
  color: #4b5563;
  line-height: 1.4;
  margin-bottom: 10px;
}

.register-title {
  font-size: 14px;
  font-weight: bold;
  background: #f3f4f6;
  display: inline-block;
  padding: 5px 16px;
  border-radius: 20px;
  color: #1f2937;
}

.info-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 16px;
  padding: 12px 16px;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #e5e7eb;
}

.info-left {
  display: flex;
  gap: 24px;
  flex-wrap: wrap;
  align-items: center;
}

.date-range {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-wrap: wrap;
}

.info-item {
  display: flex;
  align-items: center;
  gap: 6px;
}

.info-label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
}

.info-value {
  font-size: 12px;
  color: #1f2937;
  font-weight: 500;
}

.date-input {
  padding: 5px 8px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 12px;
}

.btn-clear {
  padding: 5px 12px;
  background: #6b7280;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 11px;
  font-weight: 500;
}

.btn-clear:hover {
  background: #4b5563;
}

.btn-print {
  padding: 8px 20px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
}

.btn-print:hover {
  background: #2563eb;
}

.print-date-range {
  text-align: center;
  padding: 8px;
  margin-bottom: 16px;
  background: #fef3c7;
  border-left: 4px solid #f59e0b;
  font-size: 12px;
  color: #92400e;
  border-radius: 6px;
}

.summary-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
  justify-content: center;
  flex-wrap: wrap;
}

.stat-box {
  background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
  border-radius: 12px;
  padding: 12px 20px;
  text-align: center;
  min-width: 150px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.stat-label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #bfdbfe;
  margin-bottom: 6px;
  text-transform: uppercase;
}

.stat-number {
  display: block;
  font-size: 26px;
  font-weight: bold;
  color: white;
}

.table-wrapper {
  overflow-x: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  max-height: 65vh;
  overflow-y: auto;
}

.referral-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 10px;
  min-width: 1600px;
}

.referral-table th {
  background: #1f2937;
  color: white;
  padding: 8px 4px;
  font-weight: 600;
  text-align: center;
  border: 1px solid #374151;
  position: sticky;
  top: 0;
  z-index: 10;
}

.referral-table td {
  border: 1px solid #d1d5db;
  padding: 6px 4px;
  text-align: left;
}

.referral-table td.text-center {
  text-align: center;
}

.out-badge {
  background: #fee2e2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.in-badge {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.status-accepted {
  background: #d1fae5;
  color: #065f46;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.status-pending {
  background: #fef3c7;
  color: #92400e;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.status-rejected {
  background: #fee2e2;
  color: #dc2626;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.status-completed {
  background: #dbeafe;
  color: #1e40af;
  padding: 2px 6px;
  border-radius: 10px;
  font-size: 9px;
  font-weight: 600;
  display: inline-block;
}

.empty-row {
  text-align: center;
  padding: 30px;
  color: #6b7280;
}

@media print {
  @page {
    size: landscape;
    margin: 0.3cm;
  }

  .btn-print,
  .btn-clear,
  .date-input {
    display: none;
  }

  .info-bar {
    display: none;
  }

  .print-date-range {
    background: #fef3c7;
    margin: 10px 0;
    padding: 5px;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .summary-stats {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .register-container {
    padding: 0.2cm;
  }

  .header {
    margin-bottom: 5px;
  }

  .facility-name {
    font-size: 14px;
  }

  .facility-details {
    font-size: 8px;
  }

  .register-title {
    font-size: 10px;
  }

  .table-wrapper {
    overflow: visible !important;
    max-height: none;
  }

  .referral-table {
    font-size: 7.5px;
    min-width: 0 !important;
  }

  .referral-table th {
    padding: 3px 2px;
    font-size: 7.5px;
    background: #e5e7eb !important;
    color: black !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .referral-table td {
    padding: 3px 2px;
    font-size: 7px;
  }
}
</style>
